import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const uaEltvDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'uaEltvd30Avg',
      field: 'ua_eltv_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEltvd10Avg',
      field: 'ua_eltv_d10',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEltvd7Avg',
      field: 'ua_eltv_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEltvd3Avg',
      field: 'ua_eltv_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEltvd0Avg',
      field: 'ua_eltv_d0',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'UA eLTV',
}
